export class StoreCurrentUsers {
  static readonly type = '[Current Users] Store Current Users';
  constructor(public currentCustomerId: string) {}
}

export class StoreUsersForCases {
  static readonly type = '[Users] Store Users For Cases';
  constructor(public currentCustomerId: string) {}
}
